module.exports = __webpack_public_path__ + "media/yesterday.ef3e1e03.mp3";